import { render, staticRenderFns } from "./OrderTables.vue?vue&type=template&id=f5b4bc84&scoped=true&"
import script from "./OrderTables.vue?vue&type=script&lang=js&"
export * from "./OrderTables.vue?vue&type=script&lang=js&"
import style0 from "./OrderTables.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderTables.vue?vue&type=style&index=1&id=f5b4bc84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b4bc84",
  null
  
)

export default component.exports